<template>
<div class="chapter">
<div class="inner_page">
<div class="titleplage">
<p class="immagine3"><span>Massimo Carlotto</span></p>
<p class="immagine4"><b>THE GOODBYE KISS</b></p>
<p class="immagine2"><i>Translated from the Italian<br/>
    by Lawrence Venuti</i></p>
<div class="immagine"><img alt="" src="Images/logo.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage2.vue?2b0d68aa